import coverImg from '../../../assets/images/literature/deep-sea-cables-cover.jpg';

const SEGMENTS = [
    {
        id: 'deep-sea-cables-1',
        title: 'Deserts of the Deep',
        text: `The wrecks dissolve above us; their dust drops down from afar—
Down to the dark, to the utter dark, where the blind white sea-snakes are.
There is no sound, no echo of sound, in the deserts of the deep,
Or the great grey level plains of ooze where the shell-burred cables creep.`,
        morseText: '| | | THE WRECKS DISSOLVE ABOVE US THEIR DUST DROPS DOWN FROM AFAR BK DOWN TO THE DARK TO THE UTTER DARK WHERE THE BLIND WHITE SEA SNAKES ARE BK THERE IS NO SOUND NO ECHO OF SOUND IN THE DESERTS OF THE DEEP BK OR THE GREAT GREY LEVEL PLAINS OF OOZE WHERE THE SHELL BURRED CABLES CREEP BK',
        estimatedSeconds: { wpm15: 120, wpm20: 90, wpm25: 72 },
        questions: [
            {
                id: 'deep-sea-q1',
                question: 'Where do the "shell-burred cables" creep?',
                options: ['IN THE MOUNTAINS', 'ON THE LUNAR SURFACE', 'IN THE DESERTS OF THE DEEP', 'ACROSS THE PRAIRIES'],
                answer: 'IN THE DESERTS OF THE DEEP',
                difficulty: 'Beginner'
            }
        ]
    },
    {
        id: 'deep-sea-cables-2',
        title: 'The Womb of the World',
        text: `Here in the womb of the world—here on the tie-ribs of earth
Words, and the words of men, flicker and flutter and beat—
Warning, sorrow and gain, salutation and mirth—
For a Power troubles the Still that has neither voice nor feet.`,
        morseText: '| | HERE IN THE WOMB OF THE WORLD HERE ON THE TIE RIBS OF EARTH BK WORDS AND THE WORDS OF MEN FLICKER AND FLUTTER AND BEAT BK WARNING SORROW AND GAIN SALUTATION AND MIRTH BK FOR A POWER TROUBLES THE STILL THAT HAS NEITHER VOICE NOR FEET BK',
        estimatedSeconds: { wpm15: 110, wpm20: 82, wpm25: 66 },
        questions: [
            {
                id: 'deep-sea-q2',
                question: 'What is described as flickering, fluttering, and beating?',
                options: ['SEA SNAKES', 'THE TIE RIBS', 'WORDS OF MEN', 'THE SHIP WRECKS'],
                answer: 'WORDS OF MEN',
                difficulty: 'Intermediate'
            }
        ]
    },
    {
        id: 'deep-sea-cables-3',
        title: 'The New Word',
        text: `They have wakened the timeless Things; they have killed their father Time
Joining hands in the gloom, a league from the last of the sun.
Hush! Men talk to-day o'er the waste of the ultimate slime,
And a new Word runs between: whispering, 'Let us be one!'`,
        morseText: '| | THEY HAVE WAKENED THE TIMELESS THINGS THEY HAVE KILLED THEIR FATHER TIME BK JOINING HANDS IN THE GLOOM A LEAGUE FROM THE LAST OF THE SUN BK HUSH MEN TALK TO DAY OER THE WASTE OF THE ULTIMATE SLIME BK AND A NEW WORD RUNS BETWEEN WHISPERING LET US BE ONE BK',
        estimatedSeconds: { wpm15: 120, wpm20: 90, wpm25: 72 },
        questions: [
            {
                id: 'deep-sea-q3',
                question: "What is the 'new Word' that runs between the cables?",
                options: ['SPEED IS ALL', 'LET US BE ONE', 'TIME IS OVER', 'HELLO WORLD'],
                answer: 'LET US BE ONE',
                difficulty: 'Beginner'
            }
        ]
    }
];

export default {
    id: 'poem-the-deep-sea-cables',
    type: 'poem',
    title: 'The Deep-Sea Cables',
    author: 'Rudyard Kipling',
    publicationDate: '1893',
    coverImage: coverImg,
    genres: ['Victorian Poetry', 'Technology', 'Telegraphy', 'Communication'],
    characterLength: SEGMENTS.reduce((acc, s) => acc + s.text.length, 0),
    description: "Rudyard Kipling's powerful poem celebrating the silent, dark depths of the ocean coming alive with the words of humanity.",

    text: SEGMENTS.map(s => s.text).join('\n\n'),
    comprehensionQuestions: SEGMENTS.flatMap(s => s.questions),
    segments: SEGMENTS.map(s => ({
        ...s,
        comprehensionQuestions: s.questions.map(q => q.id)
    })),

    metadata: {
        setting: 'The Deep Ocean Floor',
        period: 'Late 19th Century (1893)',
        themes: ['Global Connection', 'Man vs Nature', 'Abyssal Depths', 'Unity'],
        difficulty: 'Intermediate',
        estimatedReadingTimeMinutes: 5,
        stanzas: 3
    }
};
